<template>
	<div style="background-color: #fff;">
		<div style="z-index: 99;  background-color: #fff;position: fixed;width: 100%;box-shadow: 0in 2.25pt 3.75pt;transition: opacity 2s ease-in; ">
			<Myheaderesa></Myheaderesa>
		</div>

		<div style="height: 60px;"></div>

		<!--====== BANNER ==========-->
		<!-- 首页轮播图 -->
		<el-carousel :interval="5000" arrow="always" height="60vh" :pause-on-hover="true">
			<el-carousel-item>
				<div class="carouselimg">
					<el-image :src="img1" fit="contain"></el-image>
					<!-- <img src="@/assets/img/123.png" alt="这里是第一场图片" /> -->
				</div>
			</el-carousel-item>
			<el-carousel-item>
				<div class="carouselimg">
					<el-image :src="img2" fit="contain"></el-image>
					<!-- <img src="" alt="这里是第二张图片" /> -->
					<h2><router-link to="/home" style="color: #fff;font-weight: bold;">查看详情</router-link></h2>
				</div>
			</el-carousel-item>
			<el-carousel-item>
				<div class="carouselimg">
					<el-image :src="img3" fit="contain"></el-image>
					<!-- <img src="@/images/images/banner5.png" alt="这里是第三张图片" /> -->
					<h2><router-link to="/homesview/cloudcourse" style="color: #fff;font-weight: bold;">查看详情</router-link></h2>
				</div>
			</el-carousel-item>
			<el-carousel-item>
				<div class="carouselimg">
					<el-image :src="img4" fit="contain"></el-image>
					<!-- <img src="@/images/images/banner4.png" alt="这里是第四张图片" /> -->
					<h2><router-link to="/homesview/resource" style="color: #fff;font-weight: bold;">查看详情</router-link></h2>
				</div>
			</el-carousel-item>
			<el-carousel-item>
				<div class="carouselimg">
					<el-image :src="img5" fit="contain"></el-image>
					<!-- <img src="@/images/images/banner7.jpg" alt="这里是第五张图片" /> -->
				</div>
			</el-carousel-item>
		</el-carousel>

		<!--====== 云课程 ==========-->
		<section>
			<div class="rows pad-bot-redu tb-space">
				<div class="container">
					<!-- TITLE & DESCRIPTION -->
					<div class="spe-title">
						<h2>打造精准的轨道交通职业技能学习平台</h2>
						<p>
							致力于城市轨道交通人才发展战略，为轨道交通专业院校、培训机构提供软件技术、知识体系、运营服务等专业化解决方案
							<br />
							集线上课程、专业资源、高效题库、数据分析于一体的一站式服务平台
						</p>
					</div>
					<el-divider></el-divider>
					<div>
						<!-- TOUR PLACE 1 -->
						<div class="title-line">
							<div class="col-md-12 col-sm-12 col-xs-12 kcdh fliex">
								<div class="col-md-6 col-sm-12 col-xs-12 kcdh_bt">
									<h3>
										<span class="coutitle">云课程</span>
										<span style="font-size: 13px;">为1+X量身打造的轨道交通职业技能等级精品课程</span>
									</h3>
								</div>
								<div class="col-md-6 col-sm-12 col-xs-12 kcdh_bt ">
									<ul class="fliex" style="justify-content: flex-end;">
										<li v-for="(item, index) in couresetype" :key="index" @click="changecourse(index)" style="cursor: pointer;">
											<i class="kcdh_dj" :class="{ active: coureseobj.Types == index }">{{ item.typename }}</i>
											&nbsp;&nbsp;
											<span>/</span>
										</li>
										<li @click="coureseobj.Types = 3" style="cursor: pointer;">
											<router-link to="/homesview/cloudcourse"><i class="kcdh_dj" :class="{ active: coureseobj.Types == 3 }">更多</i></router-link>
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div id="div_CourseList">
							<el-empty v-if="coureselist.length == 0" description="暂无课程列表"></el-empty>
							<div class="courselist flexs">
								<div class="courseitem" v-for="(item, index) in coureselist" @click="gocoudetea(item)">
									<div style="overflow: hidden;" v-if="item.CO_CoverImgUrl"><img style="height: 200px;" :src="item.CO_CoverImgUrl" alt="" /></div>
									<div style="overflow: hidden;" v-else><img style="height: 200px;" src="https://www.hngtsd.net:65535/appstatic/images/ykc1.png" alt="" /></div>
									<div class="courseitems">
										<p class="coursefonts">{{ item.CO_CoursesName }}</p>
										<p style="margin-top: 10px;">
											<span>{{ item.CO_Creator }}</span>
											|{{ item.si_name_cn }}
										</p>
										<div class="flexs courseitemstudy" style="margin-bottom: 0;">
											<p>
												<span class="fa fa-user" style="color: #1BB777;font-size: 12px;margin-right: 5px;"></span>
												<span style="color: red;">{{ item.CO_StudyCount }}</span>
												人学习
											</p>
											<!-- <p style="color: red;">未授权</p> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!--====== 资源库 ==========-->
		<section>
			<div class="rows tb-space pad-top-o pad-bot-redu">
				<div class="container">
					<!-- TITLE & DESCRIPTION -->
					<div class="spe-title1 kcdh_bt">
						<h3>
							<span class="coutitle">资源库</span>
							<span style="font-size: 13px;">丰富的资源供轨道交通专业课程搭建</span>
						</h3>
					</div>
					<!-- HOTEL GRID -->
					<div class="to-ho-hotel" style="margin-left: 10px; margin-right: 10px;">
						<!-- HOTEL GRID -->
						<div class="col-md-12 spe-title2">
							<ul class="fliex">
								<li class="spe_zy1">
									<img src="@/images/images/zy1.png" alt="" />
									<p>资源类型丰富</p>
									<p class="zy">包含视频、动画、图片、文档、音频等各类格式的学习资源</p>
								</li>
								<li>
									<img src="@/images/images/zy2.png" alt="" />
									<p><strong>资源内容专业</strong></p>
									<p class="zy">根据轨道交通专业教学知识大纲收纳大量理论加实操的学习资源</p>
								</li>
								<li>
									<img src="@/images/images/zy3.png" alt="" />
									<p><strong>资源场景高度还原</strong></p>
									<p class="zy">大量资源直接取材生产环境和实操现场，贴合企业岗位工作要求确保学以致用</p>
								</li>
								<li>
									<img src="@/images/images/zy4.png" alt="" />
									<p><strong>资源管理精细</strong></p>
									<p class="zy">资源分类结构化精细化，便于查找使用，方便快速搭建专业课程</p>
								</li>
								<li>
									<img src="@/images/images/zy5.png" alt="" />
									<p><strong>资源数据分析</strong></p>
									<p class="zy">资源数据智能统计分析，发掘热点资源，充分提升资源价值</p>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="container2">
				<div class="rows tb-space pad-top-o pad-bot-redu">
					<div class="container">
						<div class="col-md-12 zyk">
							<ul class="fliex" style="justify-content: space-around;">
								<li>
									<img src="@/images/images/sc.png" />
									<p class="zy">多类型批量上传</p>
								</li>
								<li>
									<img src="@/images/images/cc.png" />
									<p class="zy">分类结构优化存储</p>
								</li>
								<li>
									<img src="@/images/images/ybs.png" />
									<p class="zy">ECS云部署</p>
								</li>
								<li>
									<img src="@/images/images/tjfx.png" />
									<p class="zy">资源统计分析</p>
								</li>
								<li>
									<img src="@/images/images/sjfx.png" />
									<p class="zy">行为数据分析</p>
								</li>
							</ul>
						</div>
						<div class="col-md-12 zyk1">
							<ul class="fliex">
								<li><img src="@/images/images/TXT.png" /></li>
								<li><img src="@/images/images/XLS.png" /></li>
								<li><img src="@/images/images/DOC.png" /></li>
								<li><img src="@/images/images/PPT.png" /></li>
								<li><img src="@/images/images/PSD.png" /></li>
								<li><img src="@/images/images/MP3.png" /></li>
								<li><img src="@/images/images/AVI.png" /></li>
								<li><img src="@/images/images/EPS.png" /></li>
								<li><img src="@/images/images/JAR.png" /></li>
								<li><img src="@/images/images/PDF.png" /></li>
								<li><img src="@/images/images/gif.png" /></li>
								<li><img src="@/images/images/ttf.png" /></li>
							</ul>
						</div>
					</div>
					<div class="zyk_btn"><input type="button" value="进入资源库" @click="gorourse()" /></div>
				</div>
			</div>
		</section>

		<!--====== 试题库 ==========-->
		<section>
			<div class="rows tb-space pad-top-o pad-bot-redu">
				<div class="container">
					<div class="stk kcdh_bt" style="margin: 30px 0;">
						<h3>
							<span class="coutitle">试题库</span>
							<span style="font-size: 14px; color: gray;">专业丰富的试题支持多模式灵活训练</span>
						</h3>
					</div>
					<div class="col-md-12 stk1">
						<ul class="fliex">
							<li id="li1">
								<img src="@/images/images/st8.png" alt="" />
								<p class="lip"><strong>丰富题型选择</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li"><p class="p1">系统支持单选题、多选题、判断题，并支持其它题型定制开发</p></div>
							</li>
							<li id="li2">
								<img src="@/images/images/st7.png" alt="" />
								<p class="lip"><strong>可供选择的练习模式</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li">
									<p class="p1">用户可按专业、岗位、技能等级选择性进行随机、专项或模拟考试训练</p>
								</div>
							</li>
							<li id="li3">
								<img src="@/images/images/st6.png" alt="" />
								<p class="lip"><strong>快速随机做题</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li">
									<p class="p1">可以随时随地做题，系统自动组卷，随机出题，有效检测学员知识漏洞</p>
								</div>
							</li>
							<li id="li4">
								<img src="@/images/images/st5.png" alt="" />
								<p class="lip"><strong>自动阅卷与评卷</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li">
									<p class="p1">当场获得考核成绩和考试分析结果，为教学提供及时有效的评估和参考依据</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="col-md-12 stk2 stk1">
						<ul class="fliex">
							<li id="li5">
								<img src="@/images/images/st4.png" alt="" />
								<p><strong>错题本功能</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li"><p class="p1">自动错题记录帮助学员快速高效的展开针对性复习</p></div>
							</li>
							<li id="li6">
								<img src="@/images/images/st3.png" alt="" />
								<p><strong>试题解析服务</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li"><p class="p1">考试结束后，学员可以查看答案，了解正确答案和对应解析</p></div>
							</li>
							<li id="li7">
								<img src="@/images/images/st2.png" alt="" />
								<p><strong>模拟考试模块</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li">
									<p class="p1">可选题库中试题组卷，可自定义试卷标题、试题内容、分值、时间、难度等级</p>
								</div>
							</li>
							<li id="li8">
								<img src="@/images/images/st1.png" alt="" />
								<p><strong>考试成绩统计</strong></p>
								<div style="background-color:#F5F5F5;height: 76px;" class="stk_li"><p class="p1">系统可对网上考试成绩进行统计分析并给出荣誉排行</p></div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<!--====== 合作院校 ==========-->
		<section>
			<div class="rows tb-space pad-top-o pad-bot-redu">
				<div class="container">
					<div class="stk kcdh_bt" style="margin: 30px 0;">
						<h3>
							<span class="coutitle">试题库</span>
							<span style="font-size: 14px; color: gray;">合作院校排名不分先后</span>
						</h3>
					</div>
					<div class="col-md-12 hzyx2">
						<ul class="fliex">
							<li><img src="@/images/images/s_1.png" alt="" /></li>
							<li class="hzyx1_li"><img src="@/images/images/s_2.png" alt="" /></li>
							<li class="hzyx2_li"><img src="@/images/images/s_3.png" alt="" /></li>
						</ul>
						<ul class="hz_2 fliex hzyx2">
							<li><img src="@/images/images/s_4.png" alt="" /></li>
							<li class="hzyx1_li"><img src="@/images/images/s_5.png" alt="" /></li>
							<li class="hzyx2_li"><img src="@/images/images/s_6.png" alt="" /></li>
						</ul>
					</div>
				</div>
			</div>
		</section>

		<Myfooters></Myfooters>
	</div>
</template>

<script>
import AppOptions from '../config/AppOptions.vue';

import Myheaderesa from '@/components/layout/headeresa.vue';

import Myfooters from '@/components/layout/footers.vue';

import { getHomeCourseList } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	components: {
		Myheaderesa,
		Myfooters
	},
	data() {
		return {
			coureselist: [],
			coureseobj: {
				Types: 0,
				pageSize: 6,
				pageIndex: 1,
				CategoryID: '',
				ProfessionalID: '',
				PR_GUID: '',
				CourseName: '',
				si_guid: '',
				Inspectionlevel: ''
			},
			// 课程类别
			couresetype: [
				{
					typename: '最新课程'
				},
				{
					typename: '最热课程'
				},
				{
					typename: '推荐课程'
				}
			],
			img1: require('@/assets/img/123.png'),
			img2: require('@/images/images/banner6.png'),
			img3: require('@/images/images/banner5.png'),
			img4: require('@/images/images/banner4.png'),
			img5: require('@/images/images/banner7.jpg')
		};
	},
	created() {
		AppOptions.appEmpty = true;
	},
	/* 
	 beforeRouteLeave(to, from, next) {
	 	AppOptions.appEmpty = false;
	 	next();
	 },
	 
	 */
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.getlsit();
		},
		gorourse() {
			this.$router.push('/homesview/resource');
		},

		gocoudetea(itm) {
			// console.log(itm.CO_GUID,'这里进行跳转')
			this.$router.push('/cours/clouddetea?coguid=' + itm.CO_GUID);
		},
		getlsit() {
			getHomeCourseList(this.coureseobj.Types).then(res => {
				// console.log(res.data)
				// res.data.data.list
				this.coureselist = res.data.data;
			});
		},
		changecourse(i) {
			this.coureseobj.Types = i;
			this.getlsit();
		}
	}
};
</script>

<style scoped lang="less">
.flexs {
	display: flex;
	align-items: center;
}
.courselist {
	flex-wrap: wrap;

	.courseitemstudy {
		justify-content: space-between;
		margin: 10px 0;
	}

	.courseitems {
		padding: 10px;
		background-color: #fff;
		box-shadow: 10px 10px 5px white;
		height: 110px;
	}
	.coursefonts {
		font-size: 14px;
		color: #373c41;
		font-weight: 600;
	}

	.courseitem {
		width: 32%;
		margin-right: 1%;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin-bottom: 40px;
		overflow: hidden;
		// height: 230px;
		cursor: pointer;

		img {
			width: 100%;
		}
		img:hover {
			transform: scale(1.2);
			transition: all 2s;
		}
	}
}

.el-image {
	width: 100%;
}

.carouselimg {
	width: 100%;
	height: 100%;

	h2 {
		position: absolute;
		top: 67%;
		left: 19%;
		display: flex;
		height: 40px;
		width: 113px;
		border: 2px solid #fff;
		font-size: 15px;
		text-overflow: ellipsis;
		overflow: hidden;
		color: #fff;
		justify-content: center;
		align-items: center;
		z-index: 99999;
		border-radius: 100px;
		a {
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	img {
		width: 100%;
		// height: 100%;
	}
}
.fliex {
	display: flex;
}

.fliey {
	display: flex;
	flex-direction: column;
}

.container {
	background-color: #fff;

	.hzyx2 {
		ul {
			justify-content: space-around;
		}

		margin: 20px 0;
		li {
			border: 1px solid #ccc;
			padding: 20px;
			width: 30%;
			border-radius: 5px;
		}
	}

	.spe-title {
		width: 100%;
		text-align: center;
		margin: 40px 0;
		h2 {
			font-size: 34px;
			color: #000;
			margin-bottom: 20px;
			font-weight: 700;
		}

		p {
			font-size: 18px;
			color: #888;
		}
	}

	.title-line {
		.kcdh_bt {
			li {
				margin: 0 5px;
			}

			.active {
				background-color: #0054ff;
				color: #fff;
				padding: 2px 20px;
				border-radius: 10px;
			}

			.coutitle {
				font-size: 24px;
				color: #000;
				margin-right: 10px;
				font-weight: 700;
			}
		}
	}

	.coutitle {
		font-size: 24px;
		color: #000;
		margin-right: 10px;
		font-weight: 700;
	}

	#div_CourseList {
		padding: 50px 0;
	}
	/deep/ .el-divider--horizontal {
		height: 2px !important;
	}

	.stk1 {
		margin-bottom: 20px;
		ul {
			justify-content: space-between;
		}
		li {
			width: 23%;
			border: 1px solid #ccc;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: 20px;

			.lip {
				margin-top: 5px;
				font-size: 18px;
				font-weight: 700;
				color: #000;
			}

			div {
				margin-top: 20px;
				display: flex;
				align-items: center;
				box-sizing: border-box;
				padding: 0 10px;

				p {
					overflow: inherit;
					white-space: inherit;
					text-overflow: inherit;
				}
			}
		}
	}
}

.to-ho-hotel {
	.spe-title2 {
		margin: 30px 0;
		border: 1px solid #ccc;
		box-sizing: border-box;
		padding: 20px;
		border-radius: 5px;

		p {
			overflow: inherit;
			white-space: inherit;
			text-overflow: inherit;
		}

		p:nth-of-type(1) {
			font-size: 20px;
			color: #000;
			margin-top: 5px;
		}
		p:last-child {
			color: gray;
			margin-top: 5px;
		}

		li {
			width: 18%;
			display: flex;
			flex-direction: column;
			align-items: center;
			margin: 0 10px;
		}
	}
}

.container2 {
	background-color: #505dff;
	padding: 30px 0;
	.zyk {
		margin: 25px 0;
		li {
			display: flex;
			flex-direction: column;
			align-items: center;
			p {
				margin: 10px 0;
			}
		}
	}

	.zyk_btn {
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		input {
			background-color: #f5f5f5;
			color: #505dff;
			padding: 10px 20px;
			font-size: 16px;
			border-radius: 100px;
			font-weight: 700;
		}
	}

	.zyk1 {
		ul {
			justify-content: space-around;
		}
	}

	.container {
		background-color: #505dff;
		color: #fff;
	}
}
</style>
